//import type { RazorScript, User } from "@prisma/client";
import { Link, useLocation } from "@remix-run/react";
import { formatDistanceToNow } from "date-fns";
import * as React from "react";
import { FaClipboard, FaDownload, FaEdit, FaShare } from "react-icons/fa";

// @ts-ignore
import { ClientOnly } from 'remix-utils/client-only'
// @ts-ignore
import SyntaxHighlighter from '#app/components/highlight/prism';

//import CopyButton from '~/components/copyButton.client';
// // eslint-disable-next-line @typescript-eslint/ban-ts-comment
// // @ts-ignore
// import SyntaxHighlighter from '/components/highlight/prism';
 
// @ts-ignore
import razorStyles from "#app/components/highlight/styles/prism/razor";
// import DownloadButton from "./downloadButton.client";
// import RazorScriptTagLinks from "./razorScriptTagLinks";
// import ShareButton from "./shareButton.client";
import { prettyDate } from "#app/utils/dateFormat.js";
import CopyButton from "./ui/copy-button.client";
import DownloadButton from "./ui/download-button.client";
import ShareButton from "./ui/share-button.client";


export function RazorScriptDisplay({
  razorScript,
  razorScriptOwner,
  isOwner,
  language = "uorazor",
  type = "Script",
  fileName = ""
}: {
  razorScript: any;
  razorScriptOwner: string | null;
  isOwner: boolean;
  canDelete?: boolean;
  language?: string;
  type?: string;
  fileName?: string;
}) {

  const location = useLocation();
  const params = new URLSearchParams(location.hash);
  const [lineCallout, setLineCallout] = React.useState<null | number | number[]>(null);
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => {
    setMounted(true);
    const scrollToSelection = (id: string) => {
      const scrollToElement = document.getElementById(id);
      if (scrollToElement) {
          scrollToElement.scrollIntoView({ behavior: 'smooth' })
      }
    }

    setLineCallout(null);

    const hashQuery  = [...params.entries()];
    if (hashQuery.length > 0) {
      const query = hashQuery[0];
      const result = query != null && query.length ? query[0].split("#").join("") : null;
      if (result !== null && result.indexOf("L") >= 0) {

        let lines = result.replace("L","").split("-");
        if (lines.length == 2) {

          let confirmedNumbers = [];
          let start = Number(lines[0]);
          let end = Number(lines[1]);
          let diff = end - start;
          if (diff < 0) diff = 0;
          if (diff > 100) diff = 100;
          confirmedNumbers.push(start);
          if (diff > 0) {
            let index = start;
            while (confirmedNumbers.length < diff+1) {
              index++;
              confirmedNumbers.push(index);
            }
          }


          setLineCallout(confirmedNumbers)
          const firstLineMatching = result.split("-")[0]
          setTimeout(scrollToSelection, 200, firstLineMatching);
        } else {
          setLineCallout(Number(lines[0]))
          setTimeout(scrollToSelection, 200, result);
        }
        
      }
    }
  
  }, []);

  const NewLineText = (text: string) => {
    let newText = text.split('\n').map((item, i) => {
        return <p key={i}>{item}</p>;
    });
    return newText;
  }

  if (fileName.length == 0) {
    if (razorScript.content.indexOf("<?xml") >= 0) {
      fileName = `${razorScript.title}.xml`;
      language = "xml";
      type = "xml";
    } else {
      fileName = `${razorScript.title}.razor`;
    }
  }

  return (
    <div>
        <div className={"razor-script-container-whole"}>
        {/* <RazorScriptTagLinks tags={razorScript.tags} skill={razorScript.category} /> */}
        <div className={"flex flex-row gap-4"}>
            <span className="font-bold" >Created:</span> {formatDistanceToNow(razorScript.createdAt)} ago on {prettyDate(razorScript.createdAt)}
            {razorScript.createdAt != razorScript.updatedAt ? <><span className="font-bold mx-4" >Updated:</span> {formatDistanceToNow(razorScript.updatedAt)} ago on {prettyDate(razorScript.updatedAt)}</> : <></> }
            {/* <span><a href={`https://github.com/jaseowns/uo_outlands_razor_scripts/commits/main/outlands.uorazorscripts.com/script/${razorScript.id}`} target="_blank">View Change History</a></span> */}
        </div>
        

        <div className={"razor-script-button-container"}>
         {
          mounted ? 
          <ClientOnly fallback={<p>Loading...</p>}>
            {() => <CopyButton value={razorScript.content} />}
          </ClientOnly> :  <button
          className="button"
          disabled={true}
          title={"Loading copy button..."}
        >
          <span><FaClipboard className="h-4 w-4 mr-1" />Copy Script</span>
        </button>
        }

        {
          mounted ? 
          <ClientOnly fallback={<p>Loading...</p>}>
            {() => <ShareButton value={razorScript.content} />}
          </ClientOnly> :  <button
          className="button"
          disabled={true}
          title={"Loading share button..."}
        >
          <span><FaShare className="h-4 w-4 mr-1" />Share</span>
        </button>
        }

      {
          fileName.length > 0 ? 

            mounted ? 
            <ClientOnly fallback={<p>Loading...</p>}>
              {() => <DownloadButton value={razorScript.content} type={type} fileName={fileName} />}
            </ClientOnly> :  <button
            className="button"
            disabled={true}
            title={"Loading download button..."}
          >
            <span><FaDownload className="h-4 w-4 mr-1" />Download File</span>
          </button>
          : <></>
        }
       

        { isOwner ? <Link to={`/script/${razorScript.slug}/edit`}><button className="m-4 rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"><span><FaEdit className="float-left m-1 mr-2" /></span> Edit</button></Link> : <></>}

        </div>




				{/* <div className="py-4 italic error-container"><b>Note from JaseOwns:</b><br /> Scripts will be leveraged on both UORazorscipts.com and this site.  At the time of the launch (Feb 1st 2025), this isn't working right - but it will! Thanks for checking it out</div> */}
<div className="flex flex-row gap-8">
        <div>FileType: {razorScript.fileType || "No file type provided"}</div>
				<div>Size: {razorScript.size || "No size provided"}</div>
				<div>Category: {razorScript.category || "No category provided"}</div>
				<div>Skills: {razorScript.skills || "No skills provided"}</div>
				{/* <div>server: {razorScript.server || "No server provided"}</div> */}
				{/* <div>user: {razorScript.creatorId || "Anonymous User"}</div> */}
				<div>
            Hotkey: {razorScript.hotkeyCtrl ? "CTRL" : ""} {razorScript.hotkeyAlt ? "ALT" : ""} {razorScript.hotkeyShift ? "SHIFT" : ""} {razorScript.hotkey.length ? razorScript.hotkey.toUpperCase() : "No hotkey provided"}
        </div>
        </div>
        <div className="my-4 w-full">Tags: {razorScript.tags || "No tags provided"}</div>

        <div className="mb-4 w-full">
          {razorScript.description.length ? NewLineText(`Description: ${razorScript.description}`) : <p>No description provided</p>}
        </div>
        {
          razorScript.content.length > 130000 ? 
          
          <div>
            <div className="error-container" style={{marginTop:"1em"}}>
              <p>Warning: This is potentially a huge script, skipping formatting. 
                </p>
            </div>
            <h4>You can still click [Copy Script] but you may want use [Download Script] as a file instead.</h4>
            <div className="plain-content-too-big">
            {razorScript.content}
            </div>
          </div>

          : mounted ? 
          <ClientOnly>
            {()=><SyntaxHighlighter code={razorScript.content}  language={language} lineNumberCallOut={lineCallout} className={"razor-script-container"} style={razorStyles} showLineNumbers={true} />}
          </ClientOnly>
          : razorScript.content
        
        }



      </div>
    </div>
  );
}

